export default __webpack_public_path__ + "static/media/linkedInLogo.d0110d4f.png";